"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthHeaders_1 = require("../api/AuthHeaders");
exports.DEFAULT_DROPZONE_CONFIG = {
    // Change this to your upload POST address:
    url: "/File/TemporaryUpload",
    acceptedFiles: 'image/*',
    headers: {
        "Authorization": "Bearer " + AuthHeaders_1.getAuthToken()
    },
    clickable: false
};
